import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

// Componente de skeleton simplificado (apenas conteúdo, sem Card wrapper)
// Usado dentro de CardContent existente
const AnalyticsOverviewSkeleton = () => (
  <>
    {/* Primeira linha: 2 cards */}
    <div className="grid grid-cols-2 gap-3 mb-3">
      <div className="metric-card">
        <Skeleton className="h-3 w-20 mb-2" />
        <Skeleton className="h-5 w-28 mb-1" />
        <Skeleton className="h-3 w-24" />
      </div>
      <div className="metric-card">
        <Skeleton className="h-3 w-20 mb-2" />
        <Skeleton className="h-5 w-28 mb-1" />
        <Skeleton className="h-3 w-24" />
      </div>
    </div>

    {/* Segunda linha: 3 cards */}
    <div className="grid grid-cols-3 gap-3 mb-3">
      <div className="metric-card">
        <Skeleton className="h-3 w-16 mb-2" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="metric-card">
        <Skeleton className="h-3 w-16 mb-2" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="metric-card">
        <Skeleton className="h-3 w-16 mb-2" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>

    {/* Terceira linha: 3 cards */}
    <div className="grid grid-cols-3 gap-3">
      <div className="metric-card">
        <Skeleton className="h-3 w-16 mb-2" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="metric-card">
        <Skeleton className="h-3 w-16 mb-2" />
        <Skeleton className="h-4 w-20" />
      </div>
      <div className="metric-card">
        <Skeleton className="h-3 w-16 mb-2" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
  </>
);

export default AnalyticsOverviewSkeleton;
